module.exports = __webpack_public_path__ + "nato.svg?aebe2fbc90bb175b3359bd5a3a840335";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/nato.svg
// module id = 242
// module chunks = 10